"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildColony = void 0;
var SelectColony_1 = require("../inputs/SelectColony");
var DeferredAction_1 = require("./DeferredAction");
var BuildColony = (function () {
    function BuildColony(player, allowDuplicate, title, openColonies) {
        if (allowDuplicate === void 0) { allowDuplicate = false; }
        if (title === void 0) { title = 'Select where to build a colony'; }
        this.player = player;
        this.allowDuplicate = allowDuplicate;
        this.title = title;
        this.openColonies = openColonies;
        this.priority = DeferredAction_1.Priority.BUILD_COLONY;
    }
    BuildColony.prototype.execute = function () {
        var _this = this;
        if (this.openColonies === undefined) {
            this.openColonies = this.player.game.colonies.filter(function (colony) {
                return colony.colonies.length < 3 &&
                    (colony.colonies.includes(_this.player.id) === false || _this.allowDuplicate) &&
                    colony.isActive;
            });
        }
        if (this.openColonies.length === 0) {
            return undefined;
        }
        var openColonies = this.openColonies;
        var coloniesModel = this.player.game.getColoniesModel(openColonies);
        return new SelectColony_1.SelectColony(this.title, 'Build', coloniesModel, function (colonyName) {
            openColonies.forEach(function (colony) {
                if (colony.name === colonyName) {
                    colony.addColony(_this.player);
                }
                return undefined;
            });
            return undefined;
        });
    };
    return BuildColony;
}());
exports.BuildColony = BuildColony;
